export default __webpack_public_path__ + "static/bigsmile-d6c42045cca3aa1444108d6bf93293bc.jpeg";